export { default as UnderlineTabs } from './Underline';
export { default as ControlTabs } from './Control';
export { default as TextTabs } from './Text';
